window.addEventListener('DOMContentLoaded', () => {
	window.filterDashboard = function() {
    $("#filterUpcomingBookings").find("#submitQuery").click();
	}
});
